import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  cardHeaderCheckout: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '60px',
    marginBottom: '20px',
    [Theme.breakpoints.down('md')]: {
      marginTop: '50px',
    },
    [Theme.breakpoints.down('sm')]: {
      marginTop: '30px',
    },
  },
  cardTitleCheckout: {
    fontSize: Theme.typography.size[9],
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    display: 'flex',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  cardContainerCheckout: {
    flexDirection: 'row',
    background: Theme.palette.white,
    borderRadius: '5px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    padding: '40px',
    paddingTop: '30px',
    paddingBottom: '37px',
    [Theme.breakpoints.down('lg')]: {
      padding: '30px',
    },
    [Theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '20px',
      paddingTop: '30px',
      paddingBottom: '30px',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '20px',
      paddingBottom: '30px',
    },
  },
  cardContainerCheckoutWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  paymentOptionsLabel: {
    fontSize: Theme.typography.size[6],
    color: Theme.palette.primary.main,
    borderBottom: `1px solid ${Theme.palette.gray[250]}`,
    fontFamily: Theme.typography.base.semiBold,
    paddingBottom: '20px',
    marginBottom: '30px',
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[3],
      marginBottom: '20px',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    padding: '15px calc(34px - 18px) 15px 34px',
    '&:last-child': {
      marginBottom: '20px',
    },
    [Theme.breakpoints.down('lg')]: {
      padding: '15px calc(20px - 18px) 15px 20px',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '22px calc(20px - 18px) 21px 20px',
      flexDirection: 'row-reverse',
    },
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'column-reverse',
      flexBasis: '42%',
      padding: '25px 20px',
      '&:last-child': {
        marginBottom: '0',
      },
    },
    [Theme.breakpoints.up('lg')]: {
      flexDirection: 'column-reverse',
      flexBasis: '44%',
      padding: '25px 20px',
      '&:last-child': {
        marginBottom: '0',
      },
    },
  },
  infoSelected: {
    background: Theme.palette.gray[50],
  },
  infoNoMarginBottom: {
    marginBottom: '0 !important',
  },
  infoRefund: {
    display: 'flex',
    flexDirection: 'row',
    padding: '22px 17px',
    background: Theme.palette.gray[50],
    [Theme.breakpoints.up('sm')]: {
      padding: '22px 32px',
      alignItems: 'baseline',
    },
  },
  infoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '2',
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '20px',
    },
    [Theme.breakpoints.up('md')]: {
      alignItems: 'center',
    },
  },
  infoWrapperRefund: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'left',
    flexDirection: 'column',
    [Theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      '& div > span': {
        marginRight: '0px',
      },
    },
  },
  infoTitle: {
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    marginBottom: '5px',
  },
  infoDate: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.primary.main,
    [Theme.breakpoints.up('md')]: {
      marginTop: '8px',
      marginBottom: '10px',
    },
  },
  infoSelect: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  infoExtraTitle: {
    fontSize: Theme.typography.size[6],
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    marginRight: '20px',
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[4],
    },
    [Theme.breakpoints.up('md')]: {
      marginRight: '0',
    },
  },
  infoExtraTitleHideSm: {
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  infoExtraTitleShowSm: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
      marginBottom: '5px',
    },
  },
  formControlLabel: {
    marginRight: '0',
  },
  infoRadioButton: {
    color: Theme.palette.gray[500],
    '&.Mui-checked': {
      color: Theme.palette.primary.light,
      '& .MuiSvgIcon-root:last-child': {
        transform: 'scale(1.2)',
      },
    },
  },
  creditCardInformation: {
    display: 'block',
    overflow: 'hidden',
    opacity: '0',
    height: '0',
  },
  creditCardInformationOpen: {
    height: 'auto',
    opacity: '1',
    transition: 'opacity .5s .25s',
  },
  creditCardInformationClose: {
    opacity: '0',
    transition: 'opacity .5s .25s',
  },
  creditCardInfoLabel: {
    fontSize: Theme.typography.size[6],
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    marginTop: '50px',
    paddingBottom: '20px',
    borderBottom: `1px solid ${Theme.palette.gray[250]}`,
    marginBottom: '30px',
    [Theme.breakpoints.down('lg')]: {
      marginBottom: '20px',
    },
    [Theme.breakpoints.down('sm')]: {
      marginTop: '40px',
      fontSize: Theme.typography.size[3],
    },
  },
  submitBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '15px 40px 15px 40px',
    background: Theme.palette.gray[100],
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    [Theme.breakpoints.down('lg')]: {
      padding: '20px 30px 20px 30px',
    },
    [Theme.breakpoints.down('md')]: {
      padding: '20px',
    },
    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: '109px',
      justifyContent: 'center',
      paddingTop: '25px',
      paddingBottom: '30px',
    },
  },
  termsAndConditions: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
  },
  termsAndConditionsLink: {
    color: Theme.palette.primary.light,
    fontFamily: Theme.typography.base.semiBold,
    cursor: 'pointer',
  },
  termsAndConditionsCheckbox: {
    color: Theme.palette.gray[500],
    '&.Mui-checked': {
      color: Theme.palette.primary.light,
      '& .MuiSvgIcon-root:last-child': {
        transform: 'scale(1.2)',
      },
    },
  },
  termsAndConditionsModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  termsAndConditionsBody: {
    outline: 'none',
    position: 'absolute',
    width: '860px',
    backgroundColor: Theme.palette.white,
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    '& a': {
      textDecoration: 'none',
      color: Theme.palette.primary.light,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    [Theme.breakpoints.down('lg')]: {
      width: '780px',
    },
    [Theme.breakpoints.down('md')]: {
      width: '700px',
    },
    [Theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  termsAndConditionsTitle: {
    fontSize: Theme.typography.size[6],
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    padding: '60px 117px 10px 113px',
    [Theme.breakpoints.down('lg')]: {
      paddingLeft: '80px',
      paddingRight: '80px',
    },
    [Theme.breakpoints.down('md')]: {
      paddingLeft: '60px',
      paddingRight: '60px',
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[3],
      paddingTop: '40px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  termsAndConditionsContent: {
    // margin: '0 calc(117px - 15px) 0 113px',
    paddingRight: '117px',
    paddingLeft: '113px',
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[2],
    height: '456px',
    overflow: 'auto',
    marginBottom: '7px',
    '& b': {
      fontFamily: Theme.typography.base.semiBold,
    },
    [Theme.breakpoints.down('lg')]: {
      paddingLeft: '80px',
      paddingRight: '80px',
    },
    [Theme.breakpoints.down('md')]: {
      paddingLeft: '60px',
      paddingRight: '60px',
    },
    [Theme.breakpoints.down('sm')]: {
      height: '360px',
      paddingLeft: '20px',
      paddingRight: '20px',
      marginBottom: '20px',
    },
  },
  termsAndConditionsFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '30px 40px 21px 0',
    borderTop: `1px solid ${Theme.palette.gray[250]}`,
    '& button': {
      height: '50px',
      minWidth: '110px',
      fontSize: `${Theme.typography.size[3]} !important`,
    },
    [Theme.breakpoints.down('lg')]: {
      paddingBottom: '31px',
      '& button': {
        height: '40px',
        minWidth: '110px',
        fontSize: `${Theme.typography.size[3]} !important`,
      },
    },
    [Theme.breakpoints.down('md')]: {
      paddingTop: '20px',
      paddingBottom: '20px',
      paddingRight: '30px',
    },
    [Theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
      paddingBottom: '20px',
      paddingRight: '20px',
      '& button': {
        height: '50px',
        width: 'auto',
        minWidth: '110px',
        fontSize: `${Theme.typography.size[3]} !important`,
        marginTop: '0',
      },
    },
  },
  customCheckboxRoot: {
    width: '18px',
    height: '18px',
    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
    },
  },

  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '48.5%',
    [Theme.breakpoints.down('sm')]: {
      marginTop: '30px',
      '&:first-child': {
        marginTop: '0',
      },
    },
    '&.input-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${Theme.palette.error.main} !important`,
        borderWidth: '1px',
      },
    },
  },
  inputBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiOutlinedInput-input': {
      color: Theme.palette.gray[750],
      fontFamily: Theme.typography.base.regular,
      padding: '15px 20px 15px 20px',
      '&::-webkit-input-placeholder': {
        color: Theme.palette.gray[600],
        opacity: '1',
      },
      '&:-ms-input-placeholder': {
        color: Theme.palette.gray[600],
        opacity: '1',
      },
      '&::placeholder': {
        color: Theme.palette.gray[600],
        opacity: '1',
      },
      [Theme.breakpoints.down('sm')]: {
        padding: '15px 10px 15px 10px',
      },
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px',
        },
      },
      '& .Mui-disabled': {
        color: Theme.palette.gray[400],
      },
    },
  },
  errorMessage: {
    color: Theme.palette.error.main,
    fontSize: Theme.typography.size[2],
    fontFamily: Theme.typography.base.regular,
    paddingTop: '10px',
    '&.no-padding-top': {
      paddingTop: '0',
    },
  },
  dateSelectInput: {
    flexGrow: '1',
    color: Theme.palette.gray[750],
    '&:first-child': {
      marginRight: '5px',
    },
    '&:last-child': {
      marginLeft: '5px',
    },
    '& svg': {
      color: Theme.palette.primary.light,
    },
    '&.input-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${Theme.palette.error.main} !important`,
        borderWidth: '1px',
      },
    },
    '& .MuiSelect-select': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
  selectDefaultValue: {
    '& .MuiSelect-select': {
      color: Theme.palette.gray[600],
      fontFamily: Theme.typography.base.regular,
    },
  },
  inputLabel: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
    marginBottom: '9px',
  },
  inputBoxWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .dateSelectInput': {
      width: '152px',
    },
    '&:last-child': {
      marginTop: '30px',
    },
    [Theme.breakpoints.down('lg')]: {
      justifyContent: 'space-between',
      '& .inputBox': {
        width: 'auto',
        marginRight: '0',
      },
      '& .dateSelectInput': {
        width: 'auto',
      },
    },
    [Theme.breakpoints.down('md')]: {
      '& .inputBox': {
        width: 'auto',
        marginRight: '0',
      },
      '& .dateSelectInput': {
        width: 'auto',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
      '& .inputWrapper': {
        '&:first-child': {
          marginRight: '0',
        },
        '&:last-child': {
          marginLeft: '0',
        },
      },
    },
  },
  cardContainerCheckoutPayment: {
    flexDirection: 'row',
    background: Theme.palette.white,
    borderRadius: '5px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    padding: '25px',

    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '15px',
    },
  },
  cvvLabel: {
    display: 'flex',
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },

  tooltipContent: {
    maxWidth: '150px',
    fontSize: Theme.typography.size[1],
    fontFamily: Theme.typography.base.regular,
    lineHeight: '150%',
    color: Theme.palette.gray[650],
    '& .icon': {
      display: 'flex',
      flexDirection: 'column',
      textTransform: 'uppercase',
      textAlign: 'center',
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.pxToRem(8),
      lineHeight: '150%',
    },
    '& .icons-container': {
      display: 'flex',
      justifyContent: 'center',
      gap: '16px',
      paddingBottom: '10px',
      '& span': {
        fontFamily: Theme.typography.base.regular,
        fontSize: Theme.typography.size[2],
      },
    },
  },
  cvvWrapper: {
    flexBasis: '33%',
    [Theme.breakpoints.up('lg')]: {
      marginLeft: '10px',
    },
    '& label.MuiFormLabel-root': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
    },

    '& svg': {
      fill: Theme.palette.primary.light,
    },
    '& .Mui-error': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
    },
    '& .MuiInputBase-root': {
      borderColor: Theme.palette.gray[850],
    },
  },
  textFieldField: {
    '&.MuiInputBase-input': {
      height: '32px !important',
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.gray[750],
    },
  },
  bottomWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px',
    paddingTop: 28,
    '& .inputWrapper': {
      flexBasis: '66%',
    },
    [Theme.breakpoints.up('md')]: {
      flexBasis: '48.5%',
      paddingTop: 0,
    },
    [Theme.breakpoints.up('lg')]: {
      gap: 0,
    },
  },
}));

export default useStyles;
